module.exports = __webpack_public_path__ + "5c321110163a9ef85dcbda762ad77095.svg";